import { gql } from "@apollo/client";

export const MUTATION_DELETE_USER_OFFER = gql`
  mutation DeleteUserOffer($userId: ID!, $offerId: ID!) {
    deleteUserOffer(userId: $userId, offerId: $offerId)
  }
`;
